import {PropsWithChildren} from "react";
import {CreateSessionProvider} from ".";

export function CreateSessionContextWrapper({children}: PropsWithChildren) {
  return <CreateSessionProvider>{children}</CreateSessionProvider>;
}
